
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import { Pagination, Autoplay } from 'swiper/modules';

const Testimonials = () => {
  return (
    <section className="testimonials">
      <h2>What Our Clients Say</h2>
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 2500 }}
        spaceBetween={20}
        centeredSlides={true} 
        loop={true} 
        breakpoints={{
          320: { slidesPerView: 1 },  
          450: { slidesPerView: 1 },  
          768: { slidesPerView: 2 },  
          1024: { slidesPerView: 3 }, 
        }}
      >
        <SwiperSlide>
          <div className="testimonial-card"  data-aos="flip-left">
            <blockquote>"This team helped us find our dream home!"</blockquote>
            <h3>- Eze Jennifer</h3>
            <p> Homeowner</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="testimonial-card" data-aos="flip-right">
            <blockquote>"A seamless experience from start to finish."</blockquote>
            <h3>- Ayomide Owoeye</h3>
            <p> Investor</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="testimonial-card" data-aos="flip-left">
            <blockquote>"Highly professional and knowledgeable team."</blockquote>
            <h3>- Oladokun Abdulrazak</h3>
            <p> Business Owner</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="testimonial-card" data-aos="flip-right">
            <blockquote>"They were helpful and attentive to our needs."</blockquote>
            <h3>-Tofunmi Emmanuel </h3> 
            <p>Renter</p>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default Testimonials;
